import type INewCustomerMessages from '.';

const addCustomerMessages: INewCustomerMessages = {
	masterOrderGuides: 'Master Order Guides',
	manageCustomers: 'Manage Customers',
	newCustomer: 'New Customer',
	save: 'Save',
	namePlaceholder: 'Name',
	nameValidationMessage: 'This field must be between 3 and 30 characters long.',
	nationalIdPlaceholder: 'National Id',
	nationalIdValidationMessage:
		'This field must be between 1 and 20 characters long.',
	showSpecIndicator: 'Show spec indicator',
	autoAddPhaseouts: 'Automatically add phaseout items',
	syncProprietaryItems: 'Sync proprietary items',
	syncDiscrepancies: 'Sync discrepancies',
	customCategories: 'Custom categories',
	syncSplits: 'Sync splits',
	cmimRestrictions: 'CMIM restrictions',
};

export default addCustomerMessages;
